export function communicationsWorkspaceIdentity(user = {}) {
  return user?.workspace_id
    || user?.tenant_id
    || user?.workspace?.id
    || user?.workspace?._id
    || user?.tenant?.id
    || user?.tenant?._id
    || 'workspace';
}

export function canonicalUnreadTotal(payload = {}) {
  const value = Number(payload?.unread_total || 0);
  return Number.isFinite(value) && value > 0 ? value : 0;
}

export function communicationDraftKey(selection = {}) {
  const threadId = String(selection?.threadId || '').trim();
  if (threadId) return `thread:${threadId}`;
  const employeeId = String(selection?.employeeId || '').trim();
  if (employeeId) return `employee:${employeeId}`;
  return 'global';
}

export function sortRecruitmentThreads(threads = []) {
  return [...(Array.isArray(threads) ? threads : [])].sort((left, right) => {
    const unreadDelta = Number(right?.unread_count || 0) - Number(left?.unread_count || 0);
    if (unreadDelta) return unreadDelta;
    return new Date(right?.last_message_at || right?.updated_at || 0).getTime()
      - new Date(left?.last_message_at || left?.updated_at || 0).getTime();
  });
}

function actionKey(action = {}) {
  return String(action?.key || action?.id || action?.requirement_id || action?.title || '').trim();
}

function actionLooksAdminOwned(action = {}) {
  const classification = String(action?.classification || '').toLowerCase();
  const actor = String(action?.actor || action?.owner || action?.responsible_party || '').toLowerCase();
  return classification === 'admin_action'
    || classification === 'osabea_action'
    || actor === 'admin'
    || actor === 'manager'
    || actor === 'osabea';
}

export function splitOnboardingActions(onboardingSync = {}) {
  const admin = Array.isArray(onboardingSync?.admin_pending_actions)
    ? onboardingSync.admin_pending_actions.filter(Boolean)
    : [];
  const adminKeys = new Set(admin.map(actionKey).filter(Boolean));
  const workerRaw = Array.isArray(onboardingSync?.worker_pending_actions)
    ? onboardingSync.worker_pending_actions
    : [];

  const worker = workerRaw.filter((action) => {
    if (!action || actionLooksAdminOwned(action)) return false;
    const key = actionKey(action);
    return !key || !adminKeys.has(key);
  });

  return { worker, admin };
}

export function buildApplicantActionsDraft({ firstName = '', actions = [] } = {}) {
  const usable = (Array.isArray(actions) ? actions : [])
    .map((action) => String(action?.title || action?.label || '').trim())
    .filter(Boolean);
  if (!usable.length) return '';

  const greeting = String(firstName || '').trim() ? `Hi ${String(firstName).trim()},` : 'Hi,';
  return [
    greeting,
    '',
    'To continue your CareOps application, we still need:',
    '',
    ...usable.map((title) => `• ${title}`),
    '',
    'Please use your secure CareOps link to complete these items. If you need help with any step, reply here and I’ll help you.',
  ].join('\n');
}

export function isRecruitmentReadOnly(onboardingSync = {}) {
  const status = String(
    onboardingSync?.lifecycle_status
    || onboardingSync?.employee_status
    || onboardingSync?.status
    || '',
  ).toLowerCase();
  const applicantStatus = String(onboardingSync?.applicant_status || '').toLowerCase();
  return ['active', 'inactive', 'active_employee'].includes(status)
    || applicantStatus === 'onboarding_complete';
}
